import { render, staticRenderFns } from "./OnOffSwitch.vue?vue&type=template&id=bc700f92&scoped=true&"
import script from "./OnOffSwitch.vue?vue&type=script&lang=js&"
export * from "./OnOffSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OnOffSwitch.vue?vue&type=style&index=0&id=bc700f92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc700f92",
  null
  
)

export default component.exports